import axios from '../config/axiosConfig';

const API_URL = '/spider';

const start = async (data) => {
  const response = await axios.post(`${API_URL}/start`, data);
  return response.data;
};

const stop = async (webTargetId) => {
  const response = await axios.post(`${API_URL}/stop`, { webTargetId });
  return response.data;
};

const getStatus = async (webTargetId) => {
  const response = await axios.get(`${API_URL}/status/${webTargetId}`);
  return response.data;
};

const spiderService = {
  start,
  stop,
  getStatus
};

export default spiderService;
